<template>
    <div class="error-message d-flex a-i-center j-content-center">
        <slot></slot>
    </div>
</template>


<style lang="scss">
@import './errorMessage.scss';
</style>